import { gql } from '@apollo/client';
import permissions from 'api/Apollo/permissions';
import useQuery from 'api/hooks/useQuery';

export const ALL_SAMPLE_EVENT_NAMES_QUERY = 'AllSampleEventNames';

export const GET_ALL_SAMPLE_EVENT_NAMES = gql`
  query ${ALL_SAMPLE_EVENT_NAMES_QUERY} {
    sampleEventNames: sample_events {
      id
      name
    }
  }
`;

export default function useQuerySampleEventNames({ ...options } = {}) {
  const { data, loading, error } = useQuery(GET_ALL_SAMPLE_EVENT_NAMES, {
    context: { permission: permissions.readSampleEvents },
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-and-network',
    ...options,
  });

  return {
    sampleEventNames: data?.sampleEventNames || [],
    loading,
    error,
  };
}
